export default {"src":"/_next/static/media/phone_white_background_24.ea2dc7c0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};